import { Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'

export default function WeightChart({ data }) {
  return (
    <div className="rounded-2xl bg-white p-3">
      <h3 className="mb-2 text-2xl font-bold text-navy-900">⚖️ 體重趨勢</h3>
      <p className="mb-2 text-lg text-gray-500">體重突然增加很多，要小心水腫喔</p>
      <ResponsiveContainer width="100%" height={260}>
        <LineChart data={data} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
          <XAxis dataKey="date" tick={{ fontSize: 14 }} />
          <YAxis domain={['auto', 'auto']} tick={{ fontSize: 14 }} unit=" kg" />
          <Tooltip labelStyle={{ fontSize: 16 }} contentStyle={{ fontSize: 18 }} />
          <Line type="monotone" dataKey="weight" stroke="#0b1f3a" strokeWidth={4} dot={{ r: 6 }} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}
